var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCube = function SvgCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55469 6.00977L10 10.0848L17.4453 6.00977",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 1.95268L17.175 5.71675C17.2732 5.77046 17.3551 5.84954 17.4123 5.94574C17.4695 6.04194 17.4997 6.15172 17.5 6.26362V13.7355C17.4997 13.8474 17.4695 13.9572 17.4123 14.0534C17.3551 14.1496 17.2732 14.2287 17.175 14.2824L10.3 18.0464C10.208 18.0968 10.1049 18.1231 10 18.1231C9.89515 18.1231 9.79198 18.0968 9.7 18.0464L2.825 14.2824C2.72683 14.2287 2.64488 14.1496 2.58772 14.0534C2.53055 13.9572 2.50025 13.8474 2.5 13.7355V6.26362C2.50025 6.15172 2.53055 6.04194 2.58772 5.94574C2.64488 5.84954 2.72683 5.77046 2.825 5.71675L9.7 1.95268C9.79198 1.90236 9.89515 1.87598 10 1.87598C10.1049 1.87598 10.208 1.90236 10.3 1.95268Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.085V18.1248",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCube;